// import ReactGA from 'react-ga';
import ReactGA from "react-ga4";
import APP_CONFIG from '../config/app.json';

// export const initGA = () => {
//   ReactGA.initialize(APP_CONFIG.ga);
//   ReactGA.set({ page:window.location.pathname + window.location.search });
//   ReactGA.pageview(window.location.pathname + window.location.search);
// }
export const initGA = () => {
  ReactGA.initialize(APP_CONFIG.ga4);
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname + window.location.search,
  })
}
 


// WEBPACK FOOTER //
// ./src/component/GA.js